var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"options":_vm.langOptions,"name":"langSelector","title":"language","size":"sm"},on:{"change":_vm.handleChangeLanguage},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }